import React from "react";
import {
  Animated,
  Text as EditableText,
  Platform,
  StyleProp,
  StyleSheet,
  TextProps,
  TextStyle,
  View,
  ViewStyle,
} from "react-native";
import FontList from "react-native-font-list";
import SVG_Svg, {
  Defs,
  GProps,
  ClipPath as SVG_ClipPath,
  ForeignObject as SVG_ForeignObject,
  G as SVG_G,
  Path as SVG_Path,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const ClipPath = Animated.createAnimatedComponent(SVG_ClipPath);
const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const ForeignObject = Animated.createAnimatedComponent(SVG_ForeignObject);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="230" height="55" viewBox="0 0 230 55" fill="none"> <desc id="IMP.BLUE">{"tProps":{"type":"PROPS","ButtonWhite?":"tButtonProps","onAnimationComplete?":"() => void","CONTACT_20US?":{"style?":"tTextStyle","textOptions?":"TextProps","innerHTML?":"string"}},"#ButtonWhite":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.ButtonWhite?.onPress","animation":"touchableOpacity"},"constraint":"none","width":230,"height":55},"#CONTACT_20US":{"type":"SELECTOR","tspan":{"innerHTML":"props?.CONTACT_20US?.innerHTML ?? \"CONTACT US\"","x":"7","y":"17","width":"215","height":"22"},"constraint":"xMidYMid meet","width":215,"height":22}}</desc>
 * <g id="ButtonWhite">
 * <g clip-path="url(#clip0)">
 * <path d="M0 0H230V55H0V0Z" fill="white" fill-opacity="0.01"/>
 * <text id="CONTACT US" fill="white" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="12" font-weight="600" letter-spacing="0.06em"><tspan x="73.6428" y="32.236">CONTACT US</tspan></text>
 * </g>
 * <path d="M0 0V-2H-2V0H0ZM230 0H232V-2H230V0ZM230 55V57H232V55H230ZM0 55H-2V57H0V55ZM0 2H230V-2H0V2ZM228 0V55H232V0H228ZM230 53H0V57H230V53ZM2 55V0H-2V55H2Z" fill="white"/>
 * </g>
 * <defs>
 * <clipPath id="clip0">
 * <path d="M0 0H230V55H0V0Z" fill="white"/>
 * </clipPath>
 * </defs>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"ButtonWhite?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void",
 * 		"CONTACT_20US?": {
 * 			"style?": "tTextStyle",
 * 			"textOptions?": "TextProps",
 * 			"innerHTML?": "string"
 * 		}
 * 	},
 * 	"#ButtonWhite": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.ButtonWhite?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "none",
 * 		"width": 230,
 * 		"height": 55
 * 	},
 * 	"#CONTACT_20US": {
 * 		"type": "SELECTOR",
 * 		"tspan": {
 * 			"innerHTML": "props?.CONTACT_20US?.innerHTML ?? \"CONTACT US\"",
 * 			"x": "7",
 * 			"y": "17",
 * 			"width": "215",
 * 			"height": "22"
 * 		},
 * 		"constraint": "xMidYMid meet",
 * 		"width": 215,
 * 		"height": 22
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  ButtonWhite?: tButtonProps;
  onAnimationComplete?: () => void;
  CONTACT_20US?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const ButtonWhite = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  ButtonWhite?: tButtonProps;
  onAnimationComplete?: () => void;
  CONTACT_20US?: {
    style?: tTextStyle;
    textOptions?: TextProps;
    innerHTML?: string;
  };
}): JSX.Element => {
  const { CONTACT_20US } = props;
  const {
    style = {
      width: 230,
      height: 55,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    ButtonWhiteButtonOpacity: number;
  }>({
    ButtonWhiteButtonOpacity: 1,
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region ButtonWhite Button Handlers

  // eslint-disable-next-line no-shadow
  const { ButtonWhite = {} } = props;
  const { onPress: ButtonWhiteOnPress, ...ButtonWhiteProps } = ButtonWhite as tButtonProps;

  const ButtonWhiteButtonPressInFunction = () => 0;

  const ButtonWhiteButtonPressOutFunction = ButtonWhiteOnPress;

  const ButtonWhiteButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, ButtonWhiteButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const ButtonWhiteButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, ButtonWhiteButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const ButtonWhiteOnPressIn = () => {
    ButtonWhiteButtonActive(ButtonWhiteButtonPressInFunction);
  };

  const ButtonWhiteOnPressOut = () => {
    ButtonWhiteButtonInactive(ButtonWhiteButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} {...props} style={svgStyle}>
          <G
            id="ButtonWhite"
            opacity={buttonState.ButtonWhiteButtonOpacity}
            onMouseDown={ButtonWhiteOnPressIn}
            onMouseUp={ButtonWhiteOnPressOut}
            cursor="pointer"
            {...ButtonWhiteProps}
          >
            <G clipPath="url(#clip0)" id="ButtonWhite_elem0">
              <Path
                d="M0 0H230V55H0V0Z"
                fill="white"
                fillOpacity={0.01}
                id="ButtonWhite_elem0_elem1"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
              <ForeignObject key={JSON.stringify(props?.CONTACT_20US)} x={7} y={17} width={215} height={22}>
                <View
                  style={{
                    height: 22,
                    width: 215,
                  }}
                >
                  <EditableText
                    {...props?.CONTACT_20US?.textOptions}
                    style={[
                      {
                        fontSize: 12,
                        fontWeight: "normal",
                        color: "white",
                        fontFamily: checkFont("Roboto"),
                      },
                      props?.CONTACT_20US?.style,
                    ]}
                  >
                    {props?.CONTACT_20US?.innerHTML ?? "CONTACT US"}
                  </EditableText>
                </View>
              </ForeignObject>
            </G>
            <Path
              d="M0 0V-2H-2V0H0ZM230 0H232V-2H230V0ZM230 55V57H232V55H230ZM0 55H-2V57H0V55ZM0 2H230V-2H0V2ZM228 0V55H232V0H228ZM230 53H0V57H230V53ZM2 55V0H-2V55H2Z"
              fill="white"
              id="ButtonWhite_elem1"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </G>
          <Defs>
            <ClipPath id="clip0">
              <Path
                d="M0 0H230V55H0V0Z"
                fill="white"
                id="clip0_elem0"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 230 55"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G clipPath="url(#clip0)" id="ButtonWhite_elem0">
          <Path
            d="M0 0H230V55H0V0Z"
            fill="white"
            fillOpacity={0.01}
            id="ButtonWhite_elem0_elem1"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <ForeignObject key={JSON.stringify(CONTACT_20US)} x={7} y={17} width={215} height={22}>
            <View
              style={{
                height: 22,
                width: 215,
              }}
            >
              <EditableText
                {...CONTACT_20US?.textOptions}
                style={[
                  {
                    fontSize: 12,
                    fontWeight: "normal",
                    color: "white",
                    fontFamily: checkFont("Roboto"),
                  },
                  CONTACT_20US?.style,
                ]}
              >
                {CONTACT_20US?.innerHTML ?? "CONTACT US"}
              </EditableText>
            </View>
          </ForeignObject>
        </G>
        <Defs>
          <ClipPath id="clip0">
            <Path
              d="M0 0H230V55H0V0Z"
              fill="white"
              id="clip0_elem0"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 230 55"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          d="M0 0V-2H-2V0H0ZM230 0H232V-2H230V0ZM230 55V57H232V55H230ZM0 55H-2V57H0V55ZM0 2H230V-2H0V2ZM228 0V55H232V0H228ZM230 53H0V57H230V53ZM2 55V0H-2V55H2Z"
          fill="white"
          id="ButtonWhite_elem1"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Defs>
          <ClipPath id="clip0">
            <Path
              d="M0 0H230V55H0V0Z"
              fill="white"
              id="clip0_elem0"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(ButtonWhite);
